// Global imports
import '@babel/polyfill'
import Vue from 'vue'
import Meta from 'vue-meta'
import VueTypedJs from 'vue-typed-js'
import VueTippy, { TippyComponent } from 'vue-tippy'
import 'tippy.js/themes/light.css'
import { sync } from 'vuex-router-sync'
import 'default-passive-events'
//import '@/styles/app.scss'

// Application imports
import App from '@/App'
import store from '@/store'
import router from '@/router'

// Init / sync / use
Vue.config.productionTip = false
sync(store, router)

Vue.use(Meta)
Vue.use(VueTypedJs)
Vue.use(VueTippy)
Vue.component('tippy', TippyComponent)

let handleOutsideClick
Vue.directive('closable', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }

    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

// Initiate Vue
new Vue({
  created () {},
  router,
  store,
  render: h => h(App)
}).$mount('#app')
